import React, { useCallback, useMemo, useState } from "react";
import { usePWAInstall } from "../../hooks/usePWAInstall";

const PWAInstallBanner = () => {
  const { isPWA, canInstall, isIOS, install } = usePWAInstall();

  // Chỉ ẩn tạm trong phiên hiện tại.
  // Reload lại sẽ hiện lại nếu user chưa cài app.
  const [dismissed, setDismissed] = useState(false);
  const [showIOSGuide, setShowIOSGuide] = useState(false);

  const shouldShow = useMemo(() => {
    if (isPWA) {
      return false;
    }

    if (dismissed) {
      return false;
    }

    if (isIOS) {
      return true;
    }

    return canInstall;
  }, [canInstall, dismissed, isIOS, isPWA]);

  const dismissBanner = useCallback(() => {
    setDismissed(true);
  }, []);

  const handleInstall = useCallback(async () => {
    const installed = await install();

    if (installed) {
      setDismissed(true);
    }
  }, [install]);

  if (!shouldShow) {
    return null;
  }

  return (
      <div className="toast pwa-install-alert shadow bg-white show" role="alert" aria-live="assertive" aria-atomic="true">
        <div className="toast-body">
          <div className="content d-flex align-items-center mb-2">
            <i className="ri-notification-3-line fs-4 text-primary me-2" aria-hidden="true"></i>

            <h6 className="mb-0">Cài app để nhận thông báo</h6>

            <button className="btn-close ms-auto" type="button" aria-label="Close" onClick={dismissBanner}></button>
          </div>

          {isIOS ? (
              <>
            <span className="mb-2 d-block">
              Trên iPhone/iPad, bạn cần thêm app vào <strong>Màn hình chính</strong> thì mới nhận được thông báo.
            </span>

                <div className="d-flex gap-2">
                  <button type="button" className="btn btn-warning btn-sm" onClick={() => setShowIOSGuide((prev) => !prev)}>
                    {showIOSGuide ? "Ẩn hướng dẫn" : "Xem cách cài"}
                  </button>

                  <button type="button" className="btn btn-outline-secondary btn-sm" onClick={dismissBanner}>
                    Để sau
                  </button>
                </div>

                {showIOSGuide && (
                    <div className="mt-3 p-3 rounded bg-light border">
                      <div className="fw-semibold mb-2">Cách cài trên iPhone/iPad:</div>

                      <ol className="mb-0 ps-3">
                        <li>
                          Mở app bằng trình duyệt <strong>Safari</strong>.
                        </li>
                        <li>
                          Nhấn nút <strong>Chia sẻ</strong>.
                        </li>
                        <li>
                          Chọn <strong>Thêm vào Màn hình chính</strong>.
                        </li>
                        <li>
                          Nhấn <strong>Thêm</strong> để hoàn tất.
                        </li>
                      </ol>
                    </div>
                )}
              </>
          ) : (
              <>
            <span className="mb-2 d-block">
              Bạn cần cài app vào điện thoại để nhận thông báo và dùng ứng dụng thuận tiện hơn.
            </span>

                <div className="d-flex gap-2">
                  <button type="button" className="btn btn-warning btn-sm" onClick={handleInstall}>
                    Cài ngay
                  </button>

                  <button type="button" className="btn btn-outline-secondary btn-sm" onClick={dismissBanner}>
                    Để sau
                  </button>
                </div>
              </>
          )}
        </div>
      </div>
  );
};

export default PWAInstallBanner;